import {Grid} from "@leap4/frontend";
import {Route, Switch} from "react-router-dom";
import {urlService} from "../routing/urlsService";
import React from "react";
import AdvertiserLoginsPage from "./AdvertiserLogins/AdvertiserLoginsDashboardModule"
import {editAdvertiserLogins} from "./AdvertiserLogin/edit/EditAdvertiserLogins";

function AdvertiserLoginsModule() {

    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.advertiserLogins()} component={AdvertiserLoginsPage}/>
                <Route exact path={urlService.editAdvertiserLogins()} component={editAdvertiserLogins}/>
            </Switch>
        </Grid>
    )
}


export default AdvertiserLoginsModule
